import { useHandleOutsideClick } from '@/fsd/shared/model/hooks/useHandleOutsideClick';
import { IRangeDates } from '@/fsd/shared/ui/month-range-picker-with-options/model/types/IRangeDates';
import MonthRangePickerWithOptions from '@/fsd/shared/ui/month-range-picker-with-options/month-range-picker-with-options';
import cx from 'classnames';
import { useState } from 'react';
import filtersStyles from '../../FilterPanel.module.scss';
import styles from './MonthRangeField.module.scss';
import MonthRangeFieldInput from './MonthRangeFieldInput/MonthRangeFieldInput';

interface IProps {
  label: string;
  dates: IRangeDates;
  setDates: (val: IRangeDates) => void;
  className?: string;
  disabled?: boolean;
}

const MonthRangeField = ({
  label,
  className,
  disabled,
  dates,
  setDates,
}: IProps) => {
  const [selectedOption, setSelectedOption] = useState<number | undefined>(
    undefined
  );
  const [showOptions, setShowOptions] = useState<boolean>(false);

  const { elementRef } = useHandleOutsideClick<HTMLDivElement>({
    outsideClick: () => setShowOptions(false),
  });

  return (
    <div
      ref={elementRef}
      className={cx(styles.pickerWrapper, filtersStyles.filterItem, className)}
    >
      <label>{label}</label>
      <MonthRangeFieldInput
        dates={dates}
        setShowOptions={setShowOptions}
        disabled={disabled}
      />

      {showOptions && (
        <MonthRangePickerWithOptions
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          setShowOptions={setShowOptions}
          setDates={setDates}
          className={styles.options}
        />
      )}
    </div>
  );
};

export default MonthRangeField;
